import { render, staticRenderFns } from "./myfoot.vue?vue&type=template&id=195d07d3&scoped=true&"
import script from "./myfoot.vue?vue&type=script&lang=js&"
export * from "./myfoot.vue?vue&type=script&lang=js&"
import style0 from "./myfoot.vue?vue&type=style&index=0&id=195d07d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195d07d3",
  null
  
)

export default component.exports